export default "__VITE_ASSET__CjTJxG0I__ 600w, __VITE_ASSET__C5hvGndY__ 900w, __VITE_ASSET__BuT_hMxJ__ 1200w";